import React from 'react';

const template_overContent = (props) => {
  const { minHeight, paddingTop } = props
  const style = {
    minHeight: minHeight,
    backgroundColor: '#007bff',
    // backgroundColor: 'rgb(16, 113, 197)',
    borderRadius: 7.5,
    fontSize: 12,
    fontWeight: 'bold',
  }
  const textStyle = {
    paddingTop: paddingTop
  }
  return (
    <div style={style}>
      <p style={textStyle}>
        {/* 메시지 생성 */}
      </p>
    </div>
  )
}

export default template_overContent